{
  "version": 1,
  "asset_id": "a11cc52f-22c6-4f7b-8ceb-834a6f27b904",
  "project_id": "388c0797-e4d0-4666-aa47-37d804a0e684",
  "url": "/__l5e/assets-v1/a11cc52f-22c6-4f7b-8ceb-834a6f27b904/al-afandi-logo.png",
  "r2_key": "a/v1/388c0797-e4d0-4666-aa47-37d804a0e684/a11cc52f-22c6-4f7b-8ceb-834a6f27b904/al-afandi-logo.png",
  "original_filename": "al-afandi-logo.png",
  "size": 50607,
  "content_type": "image/png",
  "created_at": "2026-07-23T19:42:14Z"
}
